import ar from "./ar.json";
import cn from "./cn.json";
import en from "./en.json";
import fr from "./fr.json";
import gr from "./gr.json";
import it from "./it.json";
import pe from "./pe.json";
import po from "./po.json";
import ru from "./ru.json";
import sp from "./sp.json";
import tr from "./tr.json";

export default { ar, cn, en, fr, gr, it, pe, po, ru, sp, tr };
